import styled from '@emotion/styled'

import { MOBILE } from '../guided-toolbox/utils/breakpoints'

import { PrimaryButton, SecondaryButton } from './Button'

/** Places cancel on the left and confirm on the right, stacking confirm above cancel on mobile. */
export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  width: 100%;
  margin-top: 40px;

  ${MOBILE} {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`

export const ModalConfirmButton = PrimaryButton

export const ModalCancelButton = styled(SecondaryButton)`
  /* Push cancel to the left on desktop. */
  margin-right: auto;

  ${MOBILE} {
    margin-right: 0;
  }
`
